'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var placements = {
  SHOW_ON_HOVER: 'SHOW_ON_HOVER',
  SHOW_BELOW: 'SHOW_BELOW',
  SHOW_ABOVE: 'SHOW_ABOVE',
  DONT_SHOW: 'DONT_SHOW'
};

var loadingMode = {
  BLUR: 'BLUR',
  COLOR: 'COLOR'
};

var dimensions = {
  SIDE_BAR_WIDTH: 430,
  STORE_SIDE_BAR_WIDTH: 560,
  MOBILE_PADDING: 120,
  NO_PADDING: 0
};

var scrollAnimations = {
  NO_EFFECT: 'NO_EFFECT',
  FADE_IN: 'FADE_IN',
  GRAYSCALE: 'GRAYSCALE',
  SLIDE_UP: 'SLIDE_UP',
  EXPAND: 'EXPAND',
  SHRINK: 'SHRINK',
  ZOOM_OUT: 'ZOOM_OUT',
  ONE_COLOR: 'ONE_COLOR'
};

var overlayAnimations = {
  NO_EFFECT: 'NO_EFFECT',
  FADE_IN: 'FADE_IN',
  EXPAND: 'EXPAND',
  SLIDE_UP: 'SLIDE_UP',
  SLIDE_RIGHT: 'SLIDE_RIGHT'
};

var imageHoverAnimations = {
  NO_EFFECT: 'NO_EFFECT',
  ZOOM_IN: 'ZOOM_IN',
  BLUR: 'BLUR',
  GRAYSCALE: 'GRAYSCALE',
  SHRINK: 'SHRINK',
  INVERT: 'INVERT',
  COLOR_IN: 'COLOR_IN'
};

var mobileSwipeAnimations = {
  NO_EFFECT: 'NO_EFFECT',
  FADE: 'FADE',
  CAROUSEL: 'CAROUSEL',
  CROSSFADE: 'CROSSFADE'
};

var expandAnimations = {
  NO_EFFECT: 'NO_EFFECT',
  EXPAND: 'EXPAND',
  FADE_IN: 'FADE_IN',
  ZOOM: 'ZOOM'
};

var SENTRY_DSN = exports.SENTRY_DSN = 'https://53ff996300e94e7983242fc53bc63c5f@sentry.io/1360936';

exports.default = {
  placements: placements,
  loadingMode: loadingMode,
  dimensions: dimensions,
  scrollAnimations: scrollAnimations,
  overlayAnimations: overlayAnimations,
  imageHoverAnimations: imageHoverAnimations,
  mobileSwipeAnimations: mobileSwipeAnimations,
  expandAnimations: expandAnimations
};